import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { getPathname } from 'state/routing/selectors';
import {
    FINANCIALS_FEATURE_NAME,
    FINANCIALS_ICON_FILE_PATH,
} from 'components/financials/common/constants';
import {
    COMPARATIVE_INCOME_STATEMENT_FEATURE_NAME,
    COMPARATIVE_INCOME_STATEMENT_URL,
} from 'components/financials/comparative-income-statement/constants';
import {
    BALANCE_SHEET_TITLE,
    BALANCE_SHEET_URL,
} from 'components/financials/balanceSheet/constants';
import NavItem from 'components/app/topbar/navigation/NavItem';
import DropdownMenu from 'react-dd-menu';
import 'react-dd-menu/dist/react-dd-menu.min.css';
import { MenuItem } from 'components/menu/MenuItems';
import { RouteUrls } from 'routes/RouteConstants';
import {
    hasBalanceSheetEnabled,
    hasCrosstabEnabled,
    hasVarianceReportDashboardEnabled,
} from 'state/user/selectors';
import {
    CROSSTAB_TITLE,
    CROSSTAB_URL,
} from 'components/financials/crosstab/CrosstabConstants';
import {
    VARIANCE_REPORTING_TITLE,
    VARIANCE_REPORT_STATUS_URL,
} from 'components/financials/variance-report-status/constants';
import { usePermissions, AppFeaturePermissions } from 'contexts';

// TODO: Create reusable version of this component. It is copied from LeasesMenu.
const FinancialsMenu = ({
    isLarge,

    isBalanceSheet,
    isComparativeIncome,
    hasBalanceSheet,
    hasCrosstab,
    isCrosstab,
    isVarianceReport,
    hasVarianceReports,
}) => {
    const { featurePermissions } = usePermissions();
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const active =
        isComparativeIncome || isBalanceSheet || isCrosstab || isVarianceReport;

    const renderButton = () => (
        <NavItem
            title={isLarge ? FINANCIALS_FEATURE_NAME : ''}
            active={active}
            icon={FINANCIALS_ICON_FILE_PATH}
            onClick={toggleMenu}
            hideTooltip={true}
            dropdown
        >
            <i
                className="fa-solid fa-caret-down"
                size="lg"
                style={{
                    paddingLeft: isLarge ? '6px' : '3px',
                    fontSize: '16px',
                }}
            />
        </NavItem>
    );

    const showIncomeStatement = featurePermissions?.includes(
        AppFeaturePermissions.IncomeStatement
    );
    const showBalanceSheet = featurePermissions?.includes(
        AppFeaturePermissions.BalanceSheet
    );
    const showCrosstab = featurePermissions?.includes(
        AppFeaturePermissions.Crosstab
    );
    const showVarianceReports = featurePermissions?.includes(
        AppFeaturePermissions.VarianceReporting
    );

    if (
        !showIncomeStatement &&
        !showBalanceSheet &&
        !showCrosstab &&
        !showVarianceReports
    ) {
        return null;
    }

    return (
        <DropdownMenu
            animate={false}
            align="left"
            isOpen={isMenuOpen}
            toggle={renderButton()}
            close={toggleMenu}
        >
            {showIncomeStatement && (
                <MenuItem
                    active={isComparativeIncome}
                    style={{ width: '250px' }}
                    to={RouteUrls.FINANCIALS_COMPARATIVE_INCOME_STATEMENT}
                >
                    <span>{COMPARATIVE_INCOME_STATEMENT_FEATURE_NAME}</span>
                </MenuItem>
            )}
            {hasBalanceSheet && showBalanceSheet && (
                <MenuItem
                    active={isBalanceSheet}
                    style={{ width: '180px' }}
                    to={RouteUrls.FINANCIALS_BALANCE_SHEET}
                >
                    <span>{BALANCE_SHEET_TITLE}</span>
                </MenuItem>
            )}
            {hasCrosstab && showCrosstab && (
                <MenuItem
                    active={isCrosstab}
                    style={{ width: '180px' }}
                    to={RouteUrls.FINANCIALS_CROSSTAB}
                >
                    <span>{CROSSTAB_TITLE}</span>
                </MenuItem>
            )}
            {hasVarianceReports && showVarianceReports && (
                <MenuItem
                    active={isVarianceReport}
                    style={{ width: '250px' }}
                    to={RouteUrls.FINANCIALS_VARIANCE_REPORT_STATUS}
                >
                    <span>{VARIANCE_REPORTING_TITLE}</span>
                </MenuItem>
            )}
        </DropdownMenu>
    );
};

export default withRouter(
    connect((state) => {
        const {
            browser: { mediaType },
        } = state;

        const currentPathName = getPathname(state);
        let activeFinancialsPage;
        if (currentPathName.includes(COMPARATIVE_INCOME_STATEMENT_URL)) {
            activeFinancialsPage = COMPARATIVE_INCOME_STATEMENT_URL;
        }
        if (currentPathName.includes(BALANCE_SHEET_URL)) {
            activeFinancialsPage = BALANCE_SHEET_URL;
        }
        if (currentPathName.includes(CROSSTAB_URL)) {
            activeFinancialsPage = CROSSTAB_URL;
        }
        if (currentPathName.includes(VARIANCE_REPORT_STATUS_URL)) {
            activeFinancialsPage = VARIANCE_REPORT_STATUS_URL;
        }
        const isComparativeIncome = currentPathName.includes(
            COMPARATIVE_INCOME_STATEMENT_URL
        );
        const isBalanceSheet = currentPathName.includes(BALANCE_SHEET_URL);
        const isCrosstab = currentPathName.includes(CROSSTAB_URL);
        const isVarianceReport = currentPathName.includes(
            VARIANCE_REPORT_STATUS_URL
        );

        return {
            isLarge: mediaType === 'lg',
            activeFinancialsPage,
            isComparativeIncome,
            isBalanceSheet,
            hasBalanceSheet: hasBalanceSheetEnabled(state),
            isCrosstab,
            hasCrosstab: hasCrosstabEnabled(state),
            isVarianceReport,
            hasVarianceReports: hasVarianceReportDashboardEnabled(state),
        };
    })(FinancialsMenu)
);
